import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import Swal from "sweetalert2";

// API Base URL
const API_URL = process.env.REACT_APP_BASE_URL;
// Fetch all sliders
export const fetchAllSliders = createAsyncThunk(
  "sliders/fetchAllSliders",
  async (_, { rejectWithValue }) => {

    // alert("S")

    try {
      const response = await axios.get(`${API_URL}/slider/fetch`);
      //console.log(response,"response")

      return response.data;
    } catch (error) {
      //console.log(error,"error")
      return rejectWithValue(error.response.data);
    }
  }
);

export const insertSlider = createAsyncThunk(
  "sliders/insertSlider",
  async (data, { rejectWithValue }) => {
    //console.log(data,"data")
    const formdata = new FormData();
    if (Array.isArray(data?.images)) {
      data.images.forEach((image, index) => {
        formdata.append(`images[${index}]`, image); // Send as an indexed array
      });
    } else {
      formdata.append("images", data?.images); // For single file
    }
    try {
      const response = await axios.post(`${API_URL}/slider/insert`, formdata, {
        headers: {
          "Content-Type": "multipart/form-data",
          // Authorization: `Bearer ${Cookies.get("token")}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const editSlider = createAsyncThunk(
  "sliders/editSlider",
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      const response = await axios.put(`${API_URL}/edit/${id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteSlider = createAsyncThunk(
  "sliders/deleteSlider",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.delete(`${API_URL}/slider/delete/${id}`, {
        headers: {
          // Authorization: `Bearer ${Cookies.get("token")}`,
        },
      });

      Swal.fire({
        icon: "success",
        title: "Deleted!",
        text: "The slider has been successfully deleted.",
        timer: 2000,
        showConfirmButton: false,
      });

      return response.data;
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: error.response?.data?.message || "Failed to delete the slider.",
        timer: 3000,
        showConfirmButton: false,
      });

      return rejectWithValue(error.response.data);
    }
  }
);
